module.exports = __webpack_public_path__ + "static/img/icon_bell.7c5962b6.svg";